function stringToColor(string) {
  // Define a palette of primary and vibrant colors
  const primaryColors = [
    '#2196F3', // Blue
    '#4CAF50', // Green
    '#FF9800', // Orange
    '#F44336', // Red
    '#9C27B0', // Purple
    '#00BCD4', // Cyan
    '#FF5722', // Deep Orange
    '#3F51B5', // Indigo
    '#8BC34A', // Light Green
    '#E91E63', // Pink
    '#795548', // Brown
    '#607D8B', // Blue Grey
    '#FFC107', // Amber
    '#009688', // Teal
    '#673AB7', // Deep Purple
    '#CDDC39', // Lime
  ];

  let hash = 0;
  for (let i = 0; i < string.length; i++) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Use the hash to select a color from the palette
  const colorIndex = Math.abs(hash) % primaryColors.length;
  return primaryColors[colorIndex];
}

export function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${name && name.length > 0 ? name.split(' ')[0][0].toUpperCase() : ''}${
      name && name.split(' ')[1] ? name.split(' ')[1][0].toUpperCase() : ''
    }`,
  };
}
